import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Interaction } from "../../models";

interface AddInteractionDialogProps {
  open: boolean;
  onClose: () => void;
  clientId: string;
  onInteractionAdded: () => void;
  interaction?: Interaction | null; // Optional prop for editing
}

const AddInteractionDialog: React.FC<AddInteractionDialogProps> = ({
  open,
  onClose,
  clientId,
  onInteractionAdded,
  interaction,
}) => {
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [note, setNote] = useState("");
  const [title, setTitle] = useState("");
  const [type, setType] = useState("meeting");

  useEffect(() => {
    if (interaction) {
      setDate(interaction.date);
      setNote(interaction.note);
      setTitle(interaction.title);
      setType(interaction.type);
    }
  }, [interaction]);

  const handleSaveInteraction = async () => {
    try {
      if (interaction) {
        // Update existing interaction
        const docRef = doc(db, "interactions", interaction.id);
        await updateDoc(docRef, {
          id: interaction.id, // Ensure the document has its ID
          date,
          note,
          title,
          type,
        });
      } else {
        // Add new interaction
        const docRef = await addDoc(collection(db, "interactions"), {
          clientId,
          date,
          note,
          title,
          type,
        });

        // Update the document with its ID after creation
        await updateDoc(docRef, {
          id: docRef.id, // Save the document ID as part of the document data
        });
      }
      onInteractionAdded();
      onClose();
    } catch (error) {
      console.error("Error saving interaction:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {interaction ? "Edit Interaction" : "Add Interaction"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Type"
          select
          value={type}
          onChange={(e) => setType(e.target.value)}
          fullWidth
          margin="normal"
          defaultValue={"meeting"}
        >
          <MenuItem value="meeting">Meeting</MenuItem>
          <MenuItem value="phone call">Phone Call</MenuItem>
          <MenuItem value="thoughts">Thoughts</MenuItem>
          <MenuItem value="email">Email</MenuItem>
          <MenuItem value="text">Text</MenuItem>
        </TextField>
        <TextField
          label="Note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSaveInteraction} color="primary">
          {interaction ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddInteractionDialog;
